var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, } from "react";
import classNames from "classnames";
import AntCheckbox from "antd/es/checkbox";
const Checkbox = forwardRef((_a, ref) => {
    var { children, className, required, size = "default" } = _a, props = __rest(_a, ["children", "className", "required", "size"]);
    const classes = classNames("gerudo-checkbox", size ? ` ${size}` : "", className);
    return (React.createElement(AntCheckbox, Object.assign({}, props, { className: classes, ref: ref }),
        React.createElement("div", { className: "children" },
            children,
            required && React.createElement("span", { className: "required-star" }, "*"))));
});
Checkbox.displayName = "Checkbox";
export default Checkbox;
export { Checkbox };
//# sourceMappingURL=Checkbox.js.map